import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admtopbar',
  templateUrl: './admtopbar.component.html',
  styleUrls: ['./admtopbar.component.scss']
})
export class AdmtopbarComponent implements OnInit {

  admUserDetails: any;

  constructor(private router: Router) {
    this.admUserDetails = JSON.parse(localStorage.getItem('admLoginDetails'));
   }

  ngOnInit() {
  }

  logOut() {
    localStorage.clear();
    this.router.navigateByUrl("adminlogin");
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admtopbar/admtopbar.component.ts